import React, { Fragment} from 'react';

const TabsUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row">
        <div className="left">
          <h1 className="h1 page-title">
            Tabs are used to alternate among related views within the same context.
          </h1>
        </div>
        <div className="right copy-content">
          <p>Tabs organize and allow navigation between groups of content that are related and at the same level of hierarchy. Each tab should contain content that is distinct from other tabs in a set.</p>
        </div>
      </article>
    </section>

    <section className="bg-grey with-padding flex-grow-1">
      <article className="flex-justify-end flex-row last">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Labels</h2>
          <p>Each tab label should describe its content and set the user expectations. Labels are concise and use one to two words maximum. Keep in mind that at mobile widths, the character length of a title will impact the experience. Icons are not permitted in Tab labels.</p>

          <h2 className="h2 page-subtitle">Number of tabs</h2>
          <p>A minimum of two tabs and a maximum of five tabs may be displayed. This is to maintain an uncluttered UI and reduce cognitive load for users.</p>

          <h2 className="h2 page-subtitle">Organization</h2>
          <p>Tab order should be consistent across an experience. Tabs with related content should be grouped adjacent to each other.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default TabsUsage;



// WEBPACK FOOTER //
// ./src/containers/elements/Tabs/TabsUsage.js